import React from 'react';
import { Redirect } from 'react-router';
import { ERoutesCommon } from 'common/models/routesModel';

const RootPageComponent: React.FC = () => {
  return <Redirect to={ERoutesCommon.Main} />;
};

export const RootPage = RootPageComponent;
